import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class BringozServiceTimeInputComponent implements IController {
  form: any;


  ngPlaceholder: string;
  serviceTime: any;
  isDisabled: boolean;
  minValue: number;
  name: string;
  onChange: Function;

  serviceTimeInMinutes: any;
  factor: number = 60000;

  constructor() {
  }

  $onInit() {
    this.serviceTimeInMinutes = undefined;
    if (!this.name) {
      this.name = 'serviceTime';
    }

    this.syncMinutesFromServiceTime();
  }

  $onChanges(changes) {
    if (changes.serviceTime && !changes.serviceTime.isFirstChange()) {
      this.syncMinutesFromServiceTime();
      this._checkValidity();
    }

    if (changes.minValue && !changes.minValue.isFirstChange()) {
      this._checkValidity();
    }
  }

  onChangeValue(serviceTimeInMinutes) {
    if (_.isNull(serviceTimeInMinutes)) {
      this.onChange({serviceTime: undefined})
    } else {
      this.onChange({serviceTime: _.toNumber((serviceTimeInMinutes * this.factor).toFixed(0))})
    }
  }

  private syncMinutesFromServiceTime(): void {
    if (this.serviceTime !== null && this.serviceTime !== undefined) {
      this.serviceTimeInMinutes = Math.round(this.serviceTime / this.factor);
    } else {
      this.serviceTimeInMinutes = null;
    }
  }

  private _checkValidity() {
    if (!this.form || !this.form[this.name]) return;

    if (this.minValue != null && this.serviceTimeInMinutes != null) {
      const valid = this.serviceTimeInMinutes >= this.minValue;
      this.form[this.name].$setValidity('min', valid);
    } else {
      this.form[this.name].$setValidity('min', true);
    }
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozServiceTimeInput', {
    require: {
      form: '?^form'
    },
    bindings: {
      ngPlaceholder: '@?',
      serviceTime: '<',
      name: '<?',
      isDisabled: '<?',
      minValue: '<?',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-service-time-input/bringoz-service-time-input.html',
    controller: BringozServiceTimeInputComponent
  });
